"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.TextField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireWildcard(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _forms = require("@morpheus-ui/forms");

var _transitionClass = _interopRequireDefault(require("../transitionClass"));

var _ThemeProvider = _interopRequireWildcard(require("./ThemeProvider"));

function _templateObject22() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  padding: ", ";\n  margin-left: ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  padding: ", ";\n  margin-right: ", ";\n  color: ", ";\n  ", ";\n\n  ", ";\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  font-family: ", ";\n  font-size: ", ";\n  min-height: ", ";\n  padding: ", ";\n  margin: ", ";\n  color: ", ";\n  padding: 2px;\n  margin-bottom: 2px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  outline: none;\n  font-size: ", ";\n  position: relative;\n  color: ", ";\n  ", ";\n\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      color: ", ";\n      font-size: ", ";\n      margin: ", ";\n\n      text-transform: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  margin: ", ";\n  text-transform: ", ";\n  position: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: ", ";\n  position: relative;\n  flex: 1;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      border-color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      background-color: ", ";\n      border-color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      background-color: ", ";\n      border-color: ", ";\n      ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n  background-color: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  ", "\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _native.default.View(_templateObject(), function (props) {
  return props.muitheme.margin;
});

var FieldContainer = _native.default.View(_templateObject2(), function (props) {
  return props.muitheme.backgroundColor;
}, function (props) {
  return props.muitheme.borderRadius;
}, function (props) {
  return props.muitheme.borderColor;
}, function (props) {
  return props.muitheme.borderWidth;
}, function (props) {
  return props.muitheme.shadow && " shadow-color: #000;\n          shadow-offset: {width: 0, height: 0};\n          shadow-opacity: 0.1;\n          shadow-radius: 8;\n      ";
}, function (props) {
  return !props.disabled && props.hasfocus.on && (0, _native.css)(_templateObject3(), function (props) {
    return props.muitheme.backgroundActiveColor;
  }, function (props) {
    return props.muitheme.borderActiveColor;
  }, props.muitheme.activeShadow && " shadow-color: #000;\n          shadow-offset: {width: 0, height: 0};\n          shadow-opacity: 0.1;\n          shadow-radius: 8;\n      ");
}, function (props) {
  return props.disabled && (0, _native.css)(_templateObject4(), function (props) {
    return props.muitheme.backgroundDisabledColor;
  }, function (props) {
    return props.muitheme.borderDisabledColor;
  });
}, function (props) {
  return props.showError && (0, _native.css)(_templateObject5(), function (props) {
    return props.muitheme.errorColor;
  });
});

var TextContainer = _native.default.View(_templateObject6(), function (props) {
  return props.muitheme.padding;
});

var Label = _native.default.Text(_templateObject7(), function (props) {
  return props.muitheme.labelFontFamily;
}, function (props) {
  return props.muitheme.labelFontSize || props.muitheme.fontSize;
}, function (props) {
  return props.muitheme.labelColor;
}, function (props) {
  return props.muitheme.labelMargin;
}, function (props) {
  return props.muitheme.labelTextTransform;
}, function (props) {
  return props.muitheme.labelPosition;
}, function (props) {
  return (props.hasfocus.on || props.hascontent.on) && (0, _native.css)(_templateObject8(), function (props) {
    return props.muitheme.labelActiveColor;
  }, function (props) {
    return props.muitheme.labelActiveFontSize;
  }, function (props) {
    return props.muitheme.labelActiveMargin;
  }, function (props) {
    return props.muitheme.labelActiveTextTransform;
  });
}, function (props) {
  return props.disabled && (0, _native.css)(_templateObject9(), function (props) {
    return props.muitheme.labelDisabledColor;
  });
}, function (props) {
  return !props.hasfocus.on && props.hascontent.on && (0, _native.css)(_templateObject10(), function (props) {
    return props.muitheme.labelWithContentColor;
  });
}, function (props) {
  return props.disabled && !props.hasfocus.on && props.hascontent.on && (0, _native.css)(_templateObject11(), function (props) {
    return props.muitheme.labelDisabledWithContentColor;
  });
});

var Field = _native.default.TextInput(_templateObject12(), function (props) {
  return props.muitheme.fontFamily;
}, function (props) {
  return props.muitheme.fontSize;
}, function (props) {
  return props.muitheme.textColor;
}, function (props) {
  return props.hasfocus.on && (0, _native.css)(_templateObject13(), function (props) {
    return props.muitheme.textActiveColor;
  });
}, function (props) {
  return props.disabledstyle.on && (0, _native.css)(_templateObject14(), function (props) {
    return props.muitheme.textDisabledColor;
  });
});

var ErrorMessage = _native.default.Text(_templateObject15(), function (props) {
  return props.muitheme.noError && "display: none";
}, function (props) {
  return props.muitheme.errorFontFamily;
}, function (props) {
  return props.muitheme.errorFontSize;
}, function (props) {
  return props.muitheme.errorMinHeight;
}, function (props) {
  return props.muitheme.errorPadding;
}, function (props) {
  return props.muitheme.errorMargin;
}, function (props) {
  return props.muitheme.errorColor;
});

var IconContainerPress = _native.default.TouchableWithoutFeedback(_templateObject16());

var IconLeftHolder = _native.default.Text(_templateObject17(), function (props) {
  return props.muitheme.iconPadding;
}, function (props) {
  return props.muitheme.iconMargin;
}, function (props) {
  return props.muitheme.iconColor;
}, function (props) {
  return props.hasfocus.on && (0, _native.css)(_templateObject18(), function (props) {
    return props.muitheme.iconActiveColor;
  });
}, function (props) {
  return props.disabled && (0, _native.css)(_templateObject19(), function (props) {
    return props.muitheme.iconDisabledColor;
  });
});

var IconRightHolder = _native.default.Text(_templateObject20(), function (props) {
  return props.muitheme.iconPadding;
}, function (props) {
  return props.muitheme.iconMargin;
}, function (props) {
  return props.muitheme.iconColor;
}, function (props) {
  return props.hasfocus.on && (0, _native.css)(_templateObject21(), function (props) {
    return props.muitheme.iconActiveColor;
  });
}, function (props) {
  return props.disabled && (0, _native.css)(_templateObject22(), function (props) {
    return props.muitheme.iconDisabledColor;
  });
});

var TextField =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TextField, _Component);

  function TextField(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getValue", function () {
      var _this$props = _this.props,
          inForm = _this$props.inForm,
          defaultValue = _this$props.defaultValue,
          value = _this$props.value,
          fieldValue = _this$props.fieldValue;

      if (inForm) {
        return value || fieldValue != null ? fieldValue : defaultValue || '';
      }

      if (value != null) {
        return value || defaultValue || '';
      }

      return _this.state.innerValue;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (text) {
      _this.setState({
        innerValue: text
      });

      _this.props.onChange && _this.props.onChange(text);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocus", function () {
      _this.setState({
        focus: true
      });

      _this.props.onFocus && _this.props.onFocus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlur", function () {
      _this.props.setDirty();

      _this.setState({
        focus: false
      });

      _this.props.onBlur && _this.props.onBlur();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSubmit", function () {
      if (_this.props.inForm) {
        _this.props.submitForm();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onPressIcon", function (position) {
      if (_this.props.onPressIcon) {
        // $FlowFixMe
        _this.props.onPressIcon({
          position: position,
          value: _this.getValue() || ''
        });
      }

      _this.props.submitOnPressIcon && _this.onSubmit();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getTextFieldTheme", (0, _memoizeOne.default)(function (props, context) {
      return (0, _ThemeProvider.getTheme)('TextField', props, context);
    }));
    _this.state = {
      focus: false,
      innerValue: _props.defaultValue || ''
    };
    return _this;
  }

  var _proto = TextField.prototype;

  _proto.getType = function getType() {
    var type = this.props.type;
    if (type === 'text') return null;
    if (type === 'email') return 'emailAdreess';
    return type;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        label = _this$props2.label,
        errorMessage = _this$props2.errorMessage,
        isSubmitted = _this$props2.isSubmitted,
        dirty = _this$props2.dirty;

    var _removeFieldProps = (0, _forms.removeFieldProps)(this.props),
        placeholder = _removeFieldProps.placeholder,
        multiline = _removeFieldProps.multiline,
        disabled = _removeFieldProps.disabled,
        inForm = _removeFieldProps.inForm,
        IconLeft = _removeFieldProps.IconLeft,
        IconRight = _removeFieldProps.IconRight,
        onPressIcon = _removeFieldProps.onPressIcon,
        submitOnPressIcon = _removeFieldProps.submitOnPressIcon,
        disableEdit = _removeFieldProps.disableEdit,
        other = (0, _objectWithoutPropertiesLoose2.default)(_removeFieldProps, ["placeholder", "multiline", "disabled", "inForm", "IconLeft", "IconRight", "onPressIcon", "submitOnPressIcon", "disableEdit"]);

    var showError = (isSubmitted() || dirty) && !!errorMessage;
    var value = this.getValue();
    var hasValue = !!value;
    var type = this.getType();
    var muitheme = this.getTextFieldTheme(this.props, this.context);
    return _react.default.createElement(Container, {
      muitheme: muitheme
    }, _react.default.createElement(FieldContainer, {
      className: _transitionClass.default,
      muitheme: muitheme,
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      showError: showError,
      disabled: disabled
    }, IconLeft && ((onPressIcon || submitOnPressIcon) && !disabled ? _react.default.createElement(IconContainerPress, {
      onPress: function onPress() {
        return _this2.onPressIcon('left');
      }
    }, _react.default.createElement(IconLeftHolder, {
      className: _transitionClass.default,
      disabled: disabled,
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      muitheme: muitheme
    }, _react.default.createElement(IconLeft, {
      width: muitheme.iconWidth,
      height: muitheme.iconHeight
    }))) : _react.default.createElement(IconLeftHolder, {
      className: _transitionClass.default,
      disabled: disabled,
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      muitheme: muitheme
    }, _react.default.createElement(IconLeft, {
      width: muitheme.iconWidth,
      height: muitheme.iconHeight
    }))), _react.default.createElement(TextContainer, {
      muitheme: muitheme
    }, _react.default.createElement(Label, {
      className: _transitionClass.default,
      muitheme: muitheme,
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      disabled: disabled
    }, label), _react.default.createElement(Field, (0, _extends2.default)({
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      muitheme: muitheme,
      textContentType: type,
      secureTextEntry: type === 'password',
      onSubmitEditing: this.onSubmit,
      multiline: multiline,
      placeholder: this.state.focus ? placeholder : null,
      disabledstyle: {
        on: disabled
      },
      disabled: disabled || disableEdit
    }, other, {
      value: value,
      onChangeText: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    }))), IconRight && ((onPressIcon || submitOnPressIcon) && !disabled ? _react.default.createElement(IconContainerPress, {
      onPress: function onPress() {
        return _this2.onPressIcon('right');
      }
    }, _react.default.createElement(IconRightHolder, {
      className: _transitionClass.default,
      disabled: disabled,
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      muitheme: muitheme
    }, _react.default.createElement(IconRight, {
      width: muitheme.iconWidth,
      height: muitheme.iconHeight
    }))) : _react.default.createElement(IconRightHolder, {
      className: _transitionClass.default,
      disabled: disabled,
      hasfocus: {
        on: this.state.focus
      },
      hascontent: {
        on: hasValue
      },
      muitheme: muitheme
    }, _react.default.createElement(IconRight, {
      width: muitheme.iconWidth,
      height: muitheme.iconHeight
    })))), _react.default.createElement(ErrorMessage, {
      muitheme: muitheme
    }, showError ? errorMessage : ''));
  };

  return TextField;
}(_react.Component);

exports.TextField = TextField;
(0, _defineProperty2.default)(TextField, "contextType", _ThemeProvider.default);

var _default = (0, _forms.turnIntoField)(TextField);

exports.default = _default;